import { render } from "./ViewDataWawancara.vue?vue&type=template&id=95af820e"
import script from "./ViewDataWawancara.vue?vue&type=script&lang=js"
export * from "./ViewDataWawancara.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__